import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';

export enum FeedbackCategory {
    NOT_FOUND = 'NOT_FOUND',
    DIFFERENT = 'DIFFERENT',
    OTHER = 'OTHER',
}

export interface FeedbackRequest {
    email: string;
    category: FeedbackCategory;
    concept?: string;
    videoFile?: File;
    description?: string;
}

export interface FeedbackResponse {
    success: boolean;
    message?: string;
}

export default class FeedbackApi {
    private readonly client: HttpClient;
    private readonly baseUrl: string;

    constructor(client: HttpClient, apiEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint + '/feedback/';
    }

    public submitFeedback(feedback: FeedbackRequest): Observable<FeedbackResponse> {
        const formData = new FormData();
        formData.append('email', feedback.email);
        formData.append('category', feedback.category);

        if (feedback.concept) {
            formData.append('concept', feedback.concept);
        }

        if (feedback.videoFile) {
            formData.append('videoFile', feedback.videoFile);
        }

        if (feedback.description) {
            formData.append('description', feedback.description);
        }

        return this.client.post<FeedbackResponse>('submit', formData, {
            baseUrl: this.baseUrl,
        });
    }
}
